const translations = {
  "en": {
    "Data Sources": "Data Sources",
    "Supported by": "Supported by"
  },
  "zh-tw": {
    "Data Sources": "數據來源",
    "Supported by": "數據來源："
  }
};

export default translations;
